module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-zucchetti"
  }, [_c('ModalReveal', {
    on: {
      "modalOpen": _vm.checkClient
    }
  }, [_c('span', {
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("Visualizza tracciato")])]), _c('div', [_c('label', [_vm._v("Enable debug")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query.debug),
      expression: "query.debug"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.query.debug) ? _vm._i(_vm.query.debug, null) > -1 : (_vm.query.debug)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.query.debug,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.query, "debug", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.query, "debug", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.query, "debug", $$c)
        }
      }
    }
  })]), _c('div', [_c('label', [_vm._v("Pn serial"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query.pn_serial),
      expression: "query.pn_serial"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.query.pn_serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.query, "pn_serial", $event.target.value)
      }
    }
  })])]), (_vm.data) ? _c('textarea', {
    domProps: {
      "value": _vm.data
    }
  }) : _vm._e(), _c('ActionButton', {
    attrs: {
      "action": _vm.download
    }
  }, [_vm._v("Load")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73ff95ca!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/modules/zucchetti/DownloadInvoiceAsEvilVersion.vue
// module id = 2593
// module chunks = 1